import styled from 'styled-components';

export const Br = styled.br<{indent: number}>`
  display: block;
  content: '';
  margin-top: ${({ indent }) => `${indent}px`};
`;
